module.exports = __webpack_public_path__ + "img/ceo_info_1_2.4c3b0ce7.svg";